/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../buttons/Button';
import Image from '../partials/Image';
import ImageCredits from '../partials/ImageCredits';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/image.module.scss';

const propTypes = {
    image: AppPropTypes.image,
    alt: PropTypes.string,
    credits: PropTypes.string,
    link: PropTypes.string,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    image: null,
    alt: null,
    credits: null,
    link: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

const ImageBlock = ({ image, alt, credits, link, className, isContainer, containerClassName }) => {
    if (image === null) return null;

    const imageComponent = <Image media={image} className={styles.image} alt={alt} />;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {link !== null ? (
                    <Button className={styles.link} href={link} external>
                        {imageComponent}
                    </Button>
                ) : (
                    imageComponent
                )}
                {credits !== null ? (
                    <ImageCredits className={styles.credit} credits={credits} />
                ) : null}
            </div>
        </div>
    );
};

ImageBlock.propTypes = propTypes;
ImageBlock.defaultProps = defaultProps;

export default ImageBlock;
